// Stile grafico dell'applicazione (D29): "bgm" con i colori del sito bigiemme.net (docs/12),
// "classico" con i colori del mockup. Si sceglie dal menu utente; la scelta resta nel browser
// del dispositivo (è una preferenza di visualizzazione, non un dato del CRM).
import { setCssVar } from 'quasar';
import { ref } from 'vue';

export type NomeTema = 'bgm' | 'classico';

interface Tema {
  descrizione: string;
  brand: Record<'primary' | 'secondary' | 'accent' | 'dark', string>;
  /** colore della barra del browser sul telefono */
  barra: string;
}

export const TEMI: Record<NomeTema, Tema> = {
  bgm: {
    descrizione: 'Bigiemme',
    // primary: arancio del marchio (#E8471E) appena più scuro, per il testo bianco sui pulsanti (4,7:1)
    brand: { primary: '#d63a17', secondary: '#4a4a4a', accent: '#0e8faa', dark: '#343a40' },
    barra: '#ffffff',
  },
  classico: {
    descrizione: 'Classico',
    brand: { primary: '#d4265f', secondary: '#161a26', accent: '#f2a900', dark: '#161a26' },
    barra: '#161a26',
  },
};

const CHIAVE = 'crm-tema';

function leggi(): NomeTema {
  try {
    const v = localStorage.getItem(CHIAVE);
    return v === 'classico' || v === 'bgm' ? v : 'bgm';
  } catch {
    return 'bgm';
  }
}

export const temaAttivo = ref<NomeTema>(leggi());

// Testo grande (D84): caratteri e pulsanti più grandi, per il dispositivo (come lo stile). Le regole in stile.css.
const CHIAVE_TESTO = 'crm-testo-grande';
function leggiTesto(): boolean {
  try {
    return localStorage.getItem(CHIAVE_TESTO) === 'S';
  } catch {
    return false;
  }
}
export const testoGrande = ref(leggiTesto());
export function applicaTesto(grande: boolean): void {
  document.documentElement.classList.toggle('testo-grande', grande);
  testoGrande.value = grande;
  try {
    localStorage.setItem(CHIAVE_TESTO, grande ? 'S' : 'N');
  } catch {
    // come per lo stile: vale solo per questa visita
  }
}

export function applicaTema(nome: NomeTema): void {
  const t = TEMI[nome];
  for (const [k, v] of Object.entries(t.brand)) setCssVar(k, v);
  // Le regole di stile.css e dei componenti leggono l'attributo per intestazione, login e carattere
  document.body.dataset.tema = nome;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', t.barra);
  temaAttivo.value = nome;
  try {
    localStorage.setItem(CHIAVE, nome);
  } catch {
    // navigazione privata o archiviazione bloccata: lo stile vale solo per questa visita
  }
}
